<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-09-18 14:41:44
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-08 12:26:40
 * @FilePath: /chaoyongtuan/src/views/teamManage/delegationHead/components/statusCell/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="flex flex-align-center">
			<div :class="['state_icon', stateClass.status]"></div>
			<div class="ml-10">{{ row.status_txt | formatEmpty }}</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	computed: {
		stateClass({ row }) {
			let calss = {
				status: '',
				label: '',
			};
			switch (row['status']) {
				case 0:
					calss.status = 'success';
					break;
				case 1:
					calss.status = 'invalid';
					break;
				case 2:
					calss.status = 'danger';
					break;
			}
			return calss;
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped>
.state_icon {
	width: 8px;
	height: 8px;
	border-radius: 50%;
}
.warning {
	background-color: @color-warning;
}
.success {
	background-color: @color-success;
}
.danger {
	background-color: @color-danger;
}
.invalid {
	background-color: @color-info;
}
</style>
